import React from "react";

const Studio = ({
  flow
}) => {
  return <div className="w-100 h-100 d-flex justify-content-center align-items-center position-relative">

       <iframe
      className="w-100 h-100 border-0"
      src={"/app/studio/" + flow.id}
      title={"studio"}
    ></iframe>

  </div>;

}

export default Studio;